import {NgModule} from '@angular/core';
import {TabsComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import TabComponent from './tab/item';
import {SegmentComponentModule} from '../segment/item.module';
import {SegmentWrapperComponentModule} from '../segment-wrapper/item.module';
import {ChipWrapperComponentModule} from '../chip-wrapper/item.module';
import {NgxOverflowShadowModule} from 'ngx-overflow-shadow';
import {DirectivesModule} from 'app/core/directives/directives.module';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf,
    NgForOf,
    SegmentWrapperComponentModule,
    ChipWrapperComponentModule,
    DirectivesModule,
    NgxOverflowShadowModule
  ],
  exports: [
    TabsComponent,
    TabComponent
  ],
  declarations: [
    TabsComponent,
    TabComponent
  ],
  providers: [],
})
export class TabsComponentModule {
}
